import { TeamColor } from '../types';
import { BATTLE_ROYALE_ANSWERS } from './answers';

/**
 * 60個の答えを6つのチームに均等に割り当てる
 * 各チーム10個ずつの答えを持つ
 */
export const generateOpAnswerMappings = (): Record<string, TeamColor> => {
  const mappings: Record<string, TeamColor> = {};
  
  // チームごとに10個ずつ割り当て
  const teamAssignments = [
    { team: TeamColor.RED, start: 0, end: 10 },      // 1-10: 法則
    { team: TeamColor.ORANGE, start: 10, end: 20 },  // 11-20: 定番
    { team: TeamColor.GREEN, start: 20, end: 30 },   // 21-30: 五十音表
    { team: TeamColor.BLUE, start: 30, end: 40 },    // 31-40: なぞなぞ
    { team: TeamColor.PURPLE, start: 40, end: 50 },  // 41-50: アルファベット
    { team: TeamColor.YELLOW, start: 50, end: 60 }   // 51-60: パズル
  ];

  teamAssignments.forEach(({ team, start, end }) => {
    for (let i = start; i < end && i < BATTLE_ROYALE_ANSWERS.length; i++) {
      const answer = BATTLE_ROYALE_ANSWERS[i];
      // すべての同義語に対してマッピングを作成
      answer.synonyms.forEach(synonym => {
        mappings[synonym] = team;
      });
      mappings[answer.canonical] = team;
    }
  });

  return mappings;
};

/**
 * プレイヤーのOP答えからownAnswerIdを生成
 */
export const getOwnAnswerId = (opAnswer: string): string => {
  // 入力された答えに対応する答えIDを検索
  for (const answer of BATTLE_ROYALE_ANSWERS) {
    if (answer.synonyms.includes(opAnswer) || answer.canonical === opAnswer) {
      return answer.id;
    }
  }
  // 見つからない場合は、入力値をそのまま使用
  return `op_${opAnswer}`;
};